<span class="material-symbols-outlined">
  {{ icon() }}
</span>
